import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import { TabSet, TabSetContent, useTabSet } from '../layout';
import CheckInLog from './CheckInLog';
import ScheduleExport from './ScheduleExport';
import RoutineExport from './routineExport';

const Export = (props) => {
   const [tabValue, _, handleTabChange] = useTabSet({
      urlParamAlias: 'exportTab',
   });

   const tabNames = props.location.routine
      ? ['Schedules', 'Future Routines', 'Check in/out log']
      : ['Schedules', 'Check in/out log'];

   return (
      <Box sx={{ width: '100%' }}>
         <TabSet value={tabValue} tabNames={tabNames} onChange={handleTabChange} />
         <Divider />
         <TabSetContent
            tabNames={tabNames}
            tabValue={tabValue}
            contentArray={[
               <ScheduleExport tab={props.tab} location={props.location} />,
               <RoutineExport tab={props.tab} location={props.location} />,
               <CheckInLog tabValue={tabValue} location={props.location} />,
            ]}
         />
      </Box>
   );
};
export default Export;
